module.exports = __webpack_public_path__ + "static/media/sell-product3.4ea02507.png";